const escRegExpSpecChars = (str: string): string =>
  str.replace(/[\\\.\+\*\?\^\$\[\]\(\)\{\}\/\'\#\:\!\=\|]/gi, '\\$&');



export { escRegExpSpecChars };
